import ApiService from './ApiService';

export default class StripeService {
  static getPaymentIntent = async (payload) =>
    ApiService.post('/payment_intent', payload);
}
